import grapesjs from 'grapesjs';
import initComponents from './components';
import initUniversalComponents from './universal-components';
import careerumComponents from './components-careerum';
import loadBlocks from './blocks-careerum';


export default grapesjs.plugins.add('gjs-blocks-careerum4.0', (editor: any, opts: any = {}) => {
  const config = {
    category: 'Careerum 4',
    ...opts
  };

  const domc = editor.DomComponents;

  // Add components
  const addTypeFromClassName = initComponents(editor, config);
  addTypeFromClassName(careerumComponents);

  initUniversalComponents(editor, config);

  // Add blocks
  loadBlocks(editor, config);

  // Define new Trait type - Goals tabs
  const goalsTimeTabType = 'data-name';
  editor.TraitManager.addType(goalsTimeTabType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(goalsTimeTabType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[goalsTimeTabType] = newVal;
    }
  });

  const goalsTimeTabComponents = [
    'club40-time-item'
  ];
  let defaultAttributesGoalsTimeTab: any = {
    required: false
  };
  defaultAttributesGoalsTimeTab[goalsTimeTabType] = '';

  goalsTimeTabComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Offer ID',
              name: goalsTimeTabType,
              type: 'text',
            }
          ],
          attributes: defaultAttributesGoalsTimeTab
        }
      }

    })
  });

  // Define new Trait type - Tariffs settings
  const tariffsType = 'data-price';
  editor.TraitManager.addType(tariffsType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(tariffsType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[tariffsType] = newVal;
    }
  });

  const tariffsComponents = [
    'club40-tariffs-item',
    'club5-tariffs-item',
  ];
  let defaultAttributesTariffs: any = {
    required: false
  };
  defaultAttributesTariffs[tariffsType] = '';

  tariffsComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена 1 мес Р',
              name: 'data-price-1m-rub',
              type: 'text',
            },
            {
              label: 'Цена 3 мес Р',
              name: 'data-price-3m-rub',
              type: 'text',
            },
            {
              label: 'Цена 3 мес полн Р',
              name: 'data-fullprice-3m-rub',
              type: 'text',
            },
            {
              label: 'Цена 6 мес Р',
              name: 'data-price-6m-rub',
              type: 'text',
            },
            {
              label: 'Цена 6 мес полн Р',
              name: 'data-fullprice-6m-rub',
              type: 'text',
            },
            {
              label: 'Цена 12 мес Р',
              name: 'data-price-12m-rub',
              type: 'text',
            },
            {
              label: 'Цена 12 мес полн Р',
              name: 'data-fullprice-12m-rub',
              type: 'text',
            },
            {
              label: 'Цена 1 мес €',
              name: 'data-price-1m-eur',
              type: 'text',
            },
            {
              label: 'Цена 3 мес €',
              name: 'data-price-3m-eur',
              type: 'text',
            },
            {
              label: 'Цена 3 мес полн €',
              name: 'data-fullprice-3m-eur',
              type: 'text',
            },
            {
              label: 'Цена 6 мес €',
              name: 'data-price-6m-eur',
              type: 'text',
            },
            {
              label: 'Цена 6 мес полн €',
              name: 'data-fullprice-6m-eur',
              type: 'text',
            },
            {
              label: 'Цена 12 мес €',
              name: 'data-price-12m-eur',
              type: 'text',
            },
            {
              label: 'Цена 12 мес полн €',
              name: 'data-fullprice-12m-eur',
              type: 'text',
            },
            {
              label: 'Цена 1 мес Р NEW',
              name: 'data-price-1m-rub-new',
              type: 'text',
            },
            {
              label: 'Цена 3 мес Р NEW',
              name: 'data-price-3m-rub-new',
              type: 'text',
            },
            {
              label: 'Цена 6 мес Р NEW',
              name: 'data-price-6m-rub-new',
              type: 'text',
            },
            {
              label: 'Цена 12 мес Р NEW',
              name: 'data-price-12m-rub-new',
              type: 'text',
            },
            {
              label: 'Цена 1 мес € NEW',
              name: 'data-price-1m-eur-new',
              type: 'text',
            },
            {
              label: 'Цена 3 мес € NEW',
              name: 'data-price-3m-eur-new',
              type: 'text',
            },
            {
              label: 'Цена 6 мес € NEW',
              name: 'data-price-6m-eur-new',
              type: 'text',
            },
            {
              label: 'Цена 12 мес € NEW',
              name: 'data-price-12m-eur-new',
              type: 'text',
            },
            {
              label: 'Оффер 1 мес P',
              name: 'data-offer-1m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 3 мес P',
              name: 'data-offer-3m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 6 мес P',
              name: 'data-offer-6m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 12 мес P',
              name: 'data-offer-12m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 1 мес €',
              name: 'data-offer-1m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 3 мес €',
              name: 'data-offer-3m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 6 мес €',
              name: 'data-offer-6m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 12 мес €',
              name: 'data-offer-12m-eur',
              type: 'text',
            }
          ],
          attributes: defaultAttributesTariffs
        }
      }

    })
  });

  
  // Define new Trait type - Tariffs settings
  const tariffsAwakeType = 'data-price';
  editor.TraitManager.addType(tariffsAwakeType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(tariffsAwakeType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[tariffsAwakeType] = newVal;
    }
  });

  const tariffsAwakeComponents = [
    'awake-tariffs-item',
  ];
  let defaultAttributesTariffsAwake: any = {
    required: false
  };
  defaultAttributesTariffsAwake[tariffsAwakeType] = '';

  tariffsAwakeComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена 1 мес Р',
              name: 'data-price-1m-rub',
              type: 'text',
            },
            {
              label: 'Старая цена 1 мес Р',
              name: 'data-oldprice-1m-rub',
              type: 'text',
            },
            {
              label: 'Скидка 1 мес Р',
              name: 'data-discount-1m-rub',
              type: 'text',
            },
            {
              label: 'Цена 3 мес Р',
              name: 'data-price-3m-rub',
              type: 'text',
            },
            {
              label: 'Цена 3 мес полн Р',
              name: 'data-fullprice-3m-rub',
              type: 'text',
            },
            {
              label: 'Старая цена 3 мес Р',
              name: 'data-oldprice-3m-rub',
              type: 'text',
            },
            {
              label: 'Скидка 3 мес Р',
              name: 'data-discount-3m-rub',
              type: 'text',
            },
            {
              label: 'Цена 6 мес Р',
              name: 'data-price-6m-rub',
              type: 'text',
            },
            {
              label: 'Цена 6 мес полн Р',
              name: 'data-fullprice-6m-rub',
              type: 'text',
            },
            {
              label: 'Старая цена 6 мес Р',
              name: 'data-oldprice-6m-rub',
              type: 'text',
            },
            {
              label: 'Скидка 6 мес Р',
              name: 'data-discount-6m-rub',
              type: 'text',
            },
            {
              label: 'Цена 12 мес Р',
              name: 'data-price-12m-rub',
              type: 'text',
            },
            {
              label: 'Цена 12 мес полн Р',
              name: 'data-fullprice-12m-rub',
              type: 'text',
            },
            {
              label: 'Старая цена 12 мес Р',
              name: 'data-oldprice-12m-rub',
              type: 'text',
            },
            {
              label: 'Скидка 12 мес Р',
              name: 'data-discount-12m-rub',
              type: 'text',
            },
            {
              label: 'Цена 1 мес €',
              name: 'data-price-1m-eur',
              type: 'text',
            },
            {
              label: 'Старая цена 1 мес €',
              name: 'data-oldprice-1m-eur',
              type: 'text',
            },
            {
              label: 'Скидка 1 мес €',
              name: 'data-discount-1m-eur',
              type: 'text',
            },
            {
              label: 'Цена 3 мес €',
              name: 'data-price-3m-eur',
              type: 'text',
            },
            {
              label: 'Цена 3 мес полн €',
              name: 'data-fullprice-3m-eur',
              type: 'text',
            },
            {
              label: 'Старая цена 3 мес €',
              name: 'data-oldprice-3m-eur',
              type: 'text',
            },
            {
              label: 'Скидка 3 мес €',
              name: 'data-discount-3m-eur',
              type: 'text',
            },
            {
              label: 'Цена 6 мес €',
              name: 'data-price-6m-eur',
              type: 'text',
            },
            {
              label: 'Цена 6 мес полн €',
              name: 'data-fullprice-6m-eur',
              type: 'text',
            },
            {
              label: 'Старая цена 6 мес €',
              name: 'data-oldprice-6m-eur',
              type: 'text',
            },
            {
              label: 'Скидка 6 мес €',
              name: 'data-discount-6m-eur',
              type: 'text',
            },
            {
              label: 'Цена 12 мес €',
              name: 'data-price-12m-eur',
              type: 'text',
            },
            {
              label: 'Цена 12 мес полн €',
              name: 'data-fullprice-12m-eur',
              type: 'text',
            },
            {
              label: 'Старая цена 12 мес €',
              name: 'data-oldprice-12m-eur',
              type: 'text',
            },
            {
              label: 'Скидка 12 мес €',
              name: 'data-discount-12m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 1 мес P',
              name: 'data-offer-1m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 3 мес P',
              name: 'data-offer-3m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 6 мес P',
              name: 'data-offer-6m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 12 мес P',
              name: 'data-offer-12m-rub',
              type: 'text',
            },
            {
              label: 'Оффер 1 мес €',
              name: 'data-offer-1m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 3 мес €',
              name: 'data-offer-3m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 6 мес €',
              name: 'data-offer-6m-eur',
              type: 'text',
            },
            {
              label: 'Оффер 12 мес €',
              name: 'data-offer-12m-eur',
              type: 'text',
            }
          ],
          attributes: defaultAttributesTariffsAwake
        }
      }

    })
  });

  // Define new Trait type - Tariffs course settings
  const tariffsCourseType = 'data-price';
  editor.TraitManager.addType(tariffsCourseType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(tariffsCourseType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[tariffsCourseType] = newVal;
    }
  });

  const tariffsCourseComponents = [
    'course40-tariffs-item'
  ];
  let defaultAttributesTariffsCourse: any = {
    required: false
  };
  defaultAttributesTariffsCourse[tariffsCourseType] = '';

  tariffsCourseComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-price-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-price-eur',
              type: 'text',
            },
            {
              label: 'Цена новая ₽',
              name: 'data-price-new-rub',
              type: 'text',
            },
            {
              label: 'Цена новая €',
              name: 'data-price-new-eur',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-href-rub',
              type: 'text',
            },
            {
              label: 'Ссылка €',
              name: 'data-href-eur',
              type: 'text',
            }
          ],
          attributes: defaultAttributesTariffsCourse
        }
      }

    })
  });


  // Define new Trait type - getcourse group
  const getcourseGroupType = 'getcourse-group';
  editor.TraitManager.addType(getcourseGroupType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(getcourseGroupType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[getcourseGroupType] = newVal;
    }
  });

  // Define new Trait type - getcourse redirect URL
  const getcourseRedirectURLType = 'getcourse-redirect-url';
  editor.TraitManager.addType(getcourseRedirectURLType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(getcourseRedirectURLType, newVal);
      // save new value of redirect url to attributes
      this.target.attributes.attributes[getcourseRedirectURLType] = newVal;
    }
  });

  const careerRequestComponents = [
    'careerum-club40-goals',
    'careerum-club40-goals-tablet',
    'careerum-club40-goals-mobile',
    'careerum-club40-form',
    'careerum-club40-form-tablet',
    'careerum-club40-form-mobile',
    'careerum-club40-popup-subscribe',
    'careerum-club40-popup-subscribe2',
    'careerum-club40-popup-pay',
    'careerum-club40-popup-pay2',
    'careerum-club40-popup-lk',
    'careerum-blackfriday-form',
    'careerum-gift',
    'careerum-veb4-main',
    'careerum-veb4-form',
    'careerum-product-form',
    'careerum-diagnostics-main',
    'careerum-validator-main',
    'careerum-career-main',
    'careerum-course41-form',
    'careerum-club5-form',
    'careerum-club40-form2',
    'careerum-club50-form',
    'careerum-lead2-form',
    'careerum-pack-form',
    'careerum-pack2-form',
    'careerum-pack3-form',
    'careerum-pack4-form',
    'careerum-club50-platform',
    'careerum-club50-popup-question',
    'careerum-intens5-form',
    'careerum-birthday-form',
    'careerum-veb50-form',
    'careerum-blackfriday2-form',
    'careerum-advent2-form',
    'careerum-pack5-form',
    'careerum-levelup0726-form',
    'careerum-globalmk-form',
    'careerum-bigpack_career-form'
  ];
  let defaultAttributes: any = {
    required: false
  };
  defaultAttributes[getcourseGroupType] = '';
  defaultAttributes[getcourseRedirectURLType] = '';

  careerRequestComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Группа в GetCourse для лидов',
              name: getcourseGroupType,
              type: getcourseGroupType,
              changeProp: 1,
            },
            {
              label: 'Редирект после добавления в группу GetCourse',
              name: getcourseRedirectURLType,
              type: getcourseRedirectURLType,
              changeProp: 1,
            },
            {
              label: 'Попап после добавления в группу (id)',
              name: 'data-popup-open',
              type: 'text',
            }
          ],
          attributes: defaultAttributes
        }
      }

    })
  });

  // Define new Trait type - timer
  const timerType = 'data-timer';
  editor.TraitManager.addType(timerType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(timerType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[timerType] = newVal;
    }
  });

  const timerComponents = [
		'careerum-course40-banner1',
    'careerum-course40-banner1-tablet',
    'careerum-course40-banner1-mobile',
    'careerum-blackfriday-banner',
    'careerum-club40-banner-top',
    'careerum-club5-banner-top-timer',
    'careerum-club50-tariffs',
    'club5-banner-top4',
    'realme-banner-top'
	];
  let defaultAttributesTimer: any = { 
    required: false
  };
  defaultAttributesTimer[timerType] = '';

  timerComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Статичная дата',
              name: 'data-static',
              type: 'checkbox',
              valueTrue: 'yes', 
              valueFalse: 'no',
            },
            {
              label: 'Дата и время окончания отсчета (08/16/2022 10:00 GMT+0300)',
              name: 'data-timer-end',
              type: 'text',
            },
            {
              label: 'Кол-во часов (для нестатичной даты)',
              name: 'data-offset',
              type: 'text',
            },
            {
              label: 'Редирект по окончании',
              name: 'data-redirect',
              type: 'checkbox',
              valueTrue: 'yes', 
              valueFalse: 'no',
            },
            {
              label: 'URL редиректа',
              name: 'data-url',
              type: 'text',
            }
          ],
          attributes: defaultAttributesTimer
        }
      }
  
    })
  });

  // Define new Trait type - club video ID
  const videoType = 'data-video-id';
  editor.TraitManager.addType(videoType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(videoType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[videoType] = newVal;
    }
  });

  const videoComponents = [
    'careerum-club40-main2',
    'awake-reviews-item',
  ];
  let defaultAttributesVideo: any = {
    required: false
  };
  defaultAttributesVideo[videoType] = '';

  videoComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Vimeo Video ID',
              name: videoType,
              type: 'text',
            }
          ],
          attributes: defaultAttributesVideo
        }
      }

    })
  });


  // Define new Trait type - Black friday tales settings
  const tariffsBFCourseType = 'data-price';
  editor.TraitManager.addType(tariffsBFCourseType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(tariffsBFCourseType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[tariffsBFCourseType] = newVal;
    }
  });

  const tariffsBFCourseComponents = [
    'blackfriday-tale-change-currency',
    'trip-tale-change-currency'
  ];
  let defaultAttributesTariffsBFCourse: any = {
    required: false
  };
  defaultAttributesTariffsBFCourse[tariffsBFCourseType] = '';

  tariffsBFCourseComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-price-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-price-eur',
              type: 'text',
            },
            {
              label: 'Цена новая ₽',
              name: 'data-price-new-rub',
              type: 'text',
            },
            {
              label: 'Цена новая €',
              name: 'data-price-new-eur',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-href-rub',
              type: 'text',
            },
            {
              label: 'Ссылка €',
              name: 'data-href-eur',
              type: 'text',
            }
          ],
          attributes: defaultAttributesTariffsBFCourse
        }
      }

    })
  });

  // Define new Trait type - data href for banner
  const hrefdataType = 'data-href';
  editor.TraitManager.addType(hrefdataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(hrefdataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[hrefdataType] = newVal;
    }
  });

  const hrefdataComponents = [
		'careerum-club40-banner-top'
	];
  let defaultAttributesHrefData: any = { 
    required: false
  };
  defaultAttributesHrefData[hrefdataType] = '';

  hrefdataComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Якорь на блок',
              name: hrefdataType,
              type: 'text',
            }
          ],
          attributes: defaultAttributesHrefData
        }
      }
  
    })
  });

  
  
  // Define new Trait type - data href for banner
  const libraryFilterDataType = 'data-filter';
  editor.TraitManager.addType(libraryFilterDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(libraryFilterDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[libraryFilterDataType] = newVal;
    }
  });

  const libraryFilterComponents = [
		'club50-library-item'
	];
  let defaultAttributesLibraryFilter: any = { 
    required: false
  };
  defaultAttributesLibraryFilter[libraryFilterDataType] = '';

  libraryFilterComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Категория',
              name: libraryFilterDataType,
              type: 'text',
            }
          ],
          attributes: defaultAttributesLibraryFilter
        }
      }
  
    })
  });
  
  // Define new Trait type - data for veb4-buy
  const veb4buyDataType = 'data-amount';
  editor.TraitManager.addType(veb4buyDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(veb4buyDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[veb4buyDataType] = newVal;
    }
  });

  const veb4buydataComponents = [
		'careerum-veb4-buy'
	];
  let defaultAttributesVeb4buy: any = { 
    required: false
  };
  defaultAttributesVeb4buy[veb4buyDataType] = '';

  veb4buydataComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-amount-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-amount-eur',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-link-rub',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-link-eur',
              type: 'text',
            },
          ],
          attributes: defaultAttributesVeb4buy
        }
      }
  
    })
  });

  
  // Define new Trait type - data for consultations tariffs
  const cons4buyDataType = 'data-price';
  editor.TraitManager.addType(cons4buyDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(cons4buyDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[cons4buyDataType] = newVal;
    }
  });

  const cons4buydataComponents = [
		'consultations4-tariffs-item'
	];
  let defaultAttributesCons4buy: any = { 
    required: false
  };
  defaultAttributesCons4buy[cons4buyDataType] = '';

  cons4buydataComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-price-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-price-eur',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-link-rub',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-link-eur',
              type: 'text',
            },
          ],
          attributes: defaultAttributesCons4buy
        }
      }
  
    })
  });

  
  // Define new Trait type - data for veb41 tariffs
  const veb41buyDataType = 'data-price';
  editor.TraitManager.addType(veb41buyDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(veb41buyDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[veb41buyDataType] = newVal;
    }
  });

  const veb41buydataComponents = [
		'veb41-price-wrapper'
	];
  let defaultAttributesveb41buy: any = { 
    required: false
  };
  defaultAttributesveb41buy[veb41buyDataType] = '';

  veb41buydataComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-price-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-price-eur',
              type: 'text',
            },
            {
              label: 'Цена old ₽',
              name: 'data-price-rub-old',
              type: 'text',
            },
            {
              label: 'Цена old €',
              name: 'data-price-eur-old',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-link-rub',
              type: 'text',
            },
            {
              label: 'Ссылка ₽',
              name: 'data-link-eur',
              type: 'text',
            },
          ],
          attributes: defaultAttributesveb41buy
        }
      }
  
    })
  });
  
  // Define new Trait type - data for club5 form tariffs
  const club5FormDataType = 'data-price';
  editor.TraitManager.addType(club5FormDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(club5FormDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[club5FormDataType] = newVal;
    }
  });

  const club5FormdataComponents = [
    'careerum-club5-form',
    'careerum-seo-form',
    'careerum-club40-form3',
	];
  let defaultAttributesClub5Form: any = { 
    required: false
  };
  defaultAttributesClub5Form[club5FormDataType] = '';

  club5FormdataComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Offer ₽',
              name: 'data-offer-rub',
              type: 'text',
            },
            {
              label: 'Offer €',
              name: 'data-offer-eur',
              type: 'text',
            },
            {
              label: 'Текст ссылки ₽',
              name: 'data-link-rub',
              type: 'text',
            },
            {
              label: 'Текст ссылки €',
              name: 'data-link-eur',
              type: 'text',
            },
          ],
          attributes: defaultAttributesClub5Form
        }
      }
  
    })
  });

  
  // Define new Trait type - Black friday tales settings
  const veb50Type = 'data-price';
  editor.TraitManager.addType(veb50Type, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(veb50Type, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[veb50Type] = newVal;
    }
  });

  const veb50Components = [
    'careerum-veb50-form'
  ];
  let defaultAttributesVeb50: any = {
    required: false
  };
  defaultAttributesVeb50[veb50Type] = '';

  veb50Components.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-price-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-price-eur',
              type: 'text',
            },
            {
              label: 'Цена old ₽',
              name: 'data-old_price-rub',
              type: 'text',
            },
            {
              label: 'Цена old €',
              name: 'data-old_price-eur',
              type: 'text',
            },
            {
              label: 'Оффер ₽',
              name: 'data-offer-rub',
              type: 'text',
            },
            {
              label: 'Оффер €',
              name: 'data-offer-eur',
              type: 'text',
            }
          ],
          attributes: defaultAttributesVeb50
        }
      }

    })
  });

  // Define new Trait type - data for validator form
  const validatorFormDataType = 'data-offer';
  editor.TraitManager.addType(validatorFormDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(validatorFormDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[validatorFormDataType] = newVal;
    }
  });

  const validatorFormComponents = [
    'careerum-validator2-form',
	];
  let defaultAttributesValidatorForm: any = { 
    required: false
  };
  defaultAttributesValidatorForm[validatorFormDataType] = '';

  validatorFormComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Offer ₽',
              name: 'data-offer-rub',
              type: 'text',
            },
            {
              label: 'Offer €',
              name: 'data-offer-eur',
              type: 'text',
            },
          ],
          attributes: defaultAttributesValidatorForm
        }
      }
  
    })
  });

  // Define new Trait type - data for BF sale
  const BFSaleDataType = 'data-offer';
  editor.TraitManager.addType(BFSaleDataType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(BFSaleDataType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[BFSaleDataType] = newVal;
    }
  });

  const BFSaleComponents = [
    'bfsale-description-bottom',
    'bfsale-description-item',
    'bfsale-tariffs-item'
	];
  let defaultAttributesBFSale: any = { 
    required: false
  };
  defaultAttributesBFSale[BFSaleDataType] = '';

  BFSaleComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {
  
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Цена ₽',
              name: 'data-price-rub',
              type: 'text',
            },
            {
              label: 'Зачеркнутая ₽',
              name: 'data-oldprice-rub',
              type: 'text',
            },
            {
              label: 'Попап ₽',
              name: 'data-popup-rub',
              type: 'text',
            },
            {
              label: 'Цена €',
              name: 'data-price-eur',
              type: 'text',
            },
            {
              label: 'Зачеркнутая €',
              name: 'data-oldprice-eur',
              type: 'text',
            },
            {
              label: 'Попап €',
              name: 'data-popup-eur',
              type: 'text',
            },
          ],
          attributes: defaultAttributesBFSale
        }
      }
  
    })
  });

  // Define new Trait type - link onclick
  const imgLoadingType = 'loading';
  editor.TraitManager.addType(imgLoadingType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(imgLoadingType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[imgLoadingType] = newVal;
    }
  });

  const imgLoadingComponents = [
		'image',
	];
  let defaultAttributesImgLoading: any = { 
    required: false
  };
  defaultAttributesImgLoading[imgLoadingType] = '';

  imgLoadingComponents.forEach((component) => {
    domc.addType(component, {
      model: {
        defaults: {
          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Loading',
              name: imgLoadingType,
              type: 'select',
              options: [ // Array of options
                { id: 'lazy', name: 'lazy'},
                { id: 'eager', name: 'eager'},
              ]
            },
            {
              label: 'srcset',
              name: 'srcset',
              type: 'text',
            },
            {
              label: 'sizes',
              name: 'sizes',
              type: 'text',
            }
          ],
          attributes: defaultAttributesImgLoading
        }
      }
    })
  });

  // Define new Trait type - data for BF sale
  const careerumSliderType = 'data-slider-init';
  editor.TraitManager.addType(careerumSliderType, {
    /**
     * Triggered when the value of the model is changed
     */
    onValueChange: function () {
      const newVal = this.model.get('value');
      this.target.set(careerumSliderType, newVal);
      // save new value of group to attributes
      this.target.attributes.attributes[careerumSliderType] = newVal;
    }
  });

  const careerumSliderComponents = [
    'careerum-slick-slider-wrapper'
	];
  const defaultAttributesCareerumSlider: any = {
    required: false
  };
  defaultAttributesCareerumSlider[careerumSliderType] = '';

  careerumSliderComponents.forEach((component) => {
    domc.addType(component, {

      model: {
        defaults: {

          traits: [
            ...domc.getType(component).model.prototype.defaults.traits,
            {
              label: 'Сладов desktop',
              name: 'data-slider-init',
              type: 'text',
            },
            {
              label: 'Сладов tablet',
              name: 'data-slider-1300',
              type: 'text',
            },
            {
              label: 'Сладов mobile',
              name: 'data-slider-768',
              type: 'text',
            }
          ],
          attributes: defaultAttributesCareerumSlider
        }
      }

    })
  });

});
